import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval, switchMap, timer } from 'rxjs';
import { AuthService } from './features/auth/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly authService = inject(AuthService);

  constructor() {
    // if (localStorage.getItem('ShuwierToken')) {
    //   // Delay the initial refresh to avoid race conditions with initial page load API calls
    //   // which would use the old token while the new token is being fetched.
    //   timer(5000)
    //     .pipe(
    //       takeUntilDestroyed(),
    //       switchMap(() => this.authService.refreshAndUpdateSession())
    //     )
    //     .subscribe();
    //   // Then refresh every 50 minutes for the lifetime of this component.
    //   interval(50 * 60 * 1000)
    //     .pipe(
    //       takeUntilDestroyed(),
    //       switchMap(() => this.authService.refreshAndUpdateSession())
    //     )
    //     .subscribe();
    // }
  }
}
